import { useEffect, useState } from 'react';
import { getCashTargets } from '../services';
import { ICashTarget } from '../types';
import { resolveErrorMessage } from './hookUtils';

interface CashTargetsState {
	targets: ICashTarget[];
	loading: boolean;
	error: string | null;
	refetch: () => void;
}

export function useCashTargets(branch?: string): CashTargetsState {
	const [targets, setTargets] = useState<ICashTarget[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);
	const [tick, setTick] = useState(0);

	useEffect(() => {
		let cancelled = false;
		setLoading(true);
		setError(null);

		getCashTargets(branch)
			.then(({ data }) => {
				if (!cancelled) {
					setTargets(data);
					setLoading(false);
				}
			})
			.catch((err) => {
				if (!cancelled) {
					setError(resolveErrorMessage(err));
					setLoading(false);
				}
			});

		return () => {
			cancelled = true;
		};
	}, [branch, tick]);

	return { targets, loading, error, refetch: () => setTick((t) => t + 1) };
}
